import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { authSelector, selectedOrganizationSelector } from "../../../../reducers/index.js";
import { useEffect, useState } from "react";
import {
  organizationGenerateHrToken,
  organizationPropertyDelete,
  organizationPropertyGet,
} from "../../../../api/index.js";
import { getIntegrations } from "../../../../actions/organization/activeintegrations.js";
import { Form, Image, Modal } from "react-bootstrap";
import { Confirmation } from "../../../../common/confirmation.jsx";
import { Button } from "../../../../common/Button.tsx";

export function SettingsHr({ setShow, active }) {
  const key = "tokenHr";

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const auth = useSelector(authSelector);
  const selectedOrganization = useSelector(selectedOrganizationSelector);

  const [token, setToken] = useState("");

  async function fetchToken() {
    const res = await organizationPropertyGet(selectedOrganization.businessIdentifier ?? auth.companyBusinessId, key);
    if (res && res.status === 200) {
      setToken(res.data);
    }
  }

  async function generateToken() {
    const res = await organizationGenerateHrToken(selectedOrganization.businessIdentifier ?? auth.companyBusinessId);
    if (res && res.status === 200) {
      return res.data;
    }
  }

  async function deleteToken() {
    const res = await organizationPropertyDelete(
      selectedOrganization.businessIdentifier ?? auth.companyBusinessId,
      key,
    );
    if (res && res.status === 200) {
      return "";
    }
  }

  useEffect(() => {
    if (active) {
      fetchToken();
    }
  }, [active]);

  const closeModal = () => setShow();

  const handleAction = async () => {
    if (!active) {
      setToken(await generateToken());
    } else {
      setToken(await deleteToken());
    }
    //dispatch(setIntegration(key, !token)); // update parent without backend call (updates active)
    if (auth.companyBusinessId) {
      dispatch(getIntegrations(selectedOrganization.businessIdentifier ?? auth.companyBusinessId)); // update parent (updates active)
    } else {
      console.error("companyBusinessId null for", auth.companyNumber);
    }
  };

  return (
    <Modal show onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title style={{ lineHeight: 2 }}>
          <Image src="/integrations/heeros-hr.svg" height={25} alt="finago HR easy" /> REST API
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!active && (
          <p>
            {t("ApiKeySet", "Määritä API-avain painamalla alla olevaa painiketta ja kopioi se alla olevasta kentästä.")}
          </p>
        )}
        <p>
          {t(
            "ApiKeySend",
            "Lähetä API-avain kaikissa pyynnöissä `HR-Authorization` -headerissa, joita teet HR API:iin.",
          )}
        </p>
        <p>
          {t("ApiKeyValidity", "Avain on voimassa, kunnes lisäät uuden avaimen tai poistat integraation käytöstä.")}
        </p>
        <Form.Group className="mb-3" controlId={key}>
          <Form.Label>HR {t("ApiKey", "API-avain")}</Form.Label>
          <Form.Control
            disabled={!active}
            readOnly
            value={token}
            onFocus={(e) => e.target.select()}
            style={{ userSelect: "all" }}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Confirmation
          title={
            active
              ? t(
                  "ApiKeyDeactivate",
                  "API-avain poistetaan ja pyynnöt rajapintaan vanhalla avaimella ei enää toimi. Haluatko poistaa integraation käytöstä",
                )
              : t("ApiKeyActivate", "Haluatko määrittää uuden API-avaimen")
          }
          actionFunction={handleAction}
        >
          <Button key="key" variant={active ? "warning" : "success"}>
            {active ? t("Deactivate", "Poista käytöstä") : t("Activate", "Ota käyttöön")}
          </Button>
        </Confirmation>
      </Modal.Footer>
    </Modal>
  );
}
